import { format, parseISO, isValid } from "date-fns";
import { id } from "date-fns/locale";

export const rupiah = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const tanggal = (s, fmt = "d MMM yyyy") => {
  if (!s) return "-";
  const d = parseISO(s);
  return isValid(d) ? format(d, fmt, { locale: id }) : s;
};

export const tanggalPanjang = (s) => tanggal(s, "EEEE, d MMMM yyyy");

export const bulanLabel = (ym) => tanggal(`${ym}-01`, "MMM yy");

const PRAYER_ORDER = ["subuh", "dzuhur", "ashar", "maghrib", "isya"];

export const PRAYER_LABELS = {
  imsak: "Imsak",
  subuh: "Subuh",
  terbit: "Terbit",
  dhuha: "Dhuha",
  dzuhur: "Dzuhur",
  ashar: "Ashar",
  maghrib: "Maghrib",
  isya: "Isya",
};

const toMin = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};

export const wibNow = (d = new Date()) => new Date(d.getTime() + (d.getTimezoneOffset() + 420) * 60000);

export function nextPrayer(times, base = new Date()) {
  if (!times) return null;
  const now = wibNow(base);
  const cur = now.getHours() * 60 + now.getMinutes() + now.getSeconds() / 60;
  for (const k of PRAYER_ORDER) {
    if (toMin(times[k]) > cur) {
      return { key: k, label: PRAYER_LABELS[k], time: times[k], remainingMin: toMin(times[k]) - cur };
    }
  }
  return { key: "subuh", label: PRAYER_LABELS.subuh, time: times.subuh, remainingMin: 1440 - cur + toMin(times.subuh), tomorrow: true };
}

export function currentPrayer(times, base = new Date()) {
  if (!times) return null;
  const now = wibNow(base);
  const cur = now.getHours() * 60 + now.getMinutes();
  let active = "isya";
  for (const k of PRAYER_ORDER) if (toMin(times[k]) <= cur) active = k;
  return active;
}

export const countdown = (min) => {
  const total = Math.max(0, Math.floor(min * 60));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};
